/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type UnlinkSkillRequestBody = {
  /**
   * The skill link ID.
   */
  linkId: string;
};

/** @internal */
export type UnlinkSkillRequestBody$Outbound = {
  link_id: string;
};

/** @internal */
export const UnlinkSkillRequestBody$outboundSchema: z.ZodMiniType<
  UnlinkSkillRequestBody$Outbound,
  UnlinkSkillRequestBody
> = z.pipe(
  z.object({
    linkId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      linkId: "link_id",
    });
  }),
);

export function unlinkSkillRequestBodyToJSON(
  unlinkSkillRequestBody: UnlinkSkillRequestBody,
): string {
  return JSON.stringify(
    UnlinkSkillRequestBody$outboundSchema.parse(unlinkSkillRequestBody),
  );
}
